<template>
  <div id="loginbg">
    <div class="login">
      <div class="login_logo">
        <div class="logo_logo"></div>
        <div class="logo_pic"></div>
      </div>
      <div class="login_dlbg">
        <div class="dlbg_title">东方神采电话调查系统</div>
        <el-input
          prefix-icon="icon dficonfont icon-ren"
          class="dlbg_username"
          v-model="login.username"
          placeholder="请输入用户名"
        ></el-input>
        <el-input
          type="password"
          prefix-icon="icon dficonfont icon-iconset0114"
          class="dlbg_password"
          v-model="login.password"
          placeholder="请输入用户名"
        ></el-input>
        <el-button class="dlbg_dlbtn" type="primary" @click="dl()"
          >登录</el-button
        >
        <div class="dlbg_company" id="dlbgText">{{ text }}</div>
      </div>
    </div>
  </div>
</template>
<script src="/phonecontrol/Tools.js"></script>

<script type="text/javascript">
// import { loginText } from "/public/login.js"; //注意路径
export default {
  data() {
    return {
      text: "北京东方艾学信息技术有限责任公司",
      // admin@126.com  aixue@123
      login: {
        username: "",
        password: "",
		loginType:'1'
      },
    };
  },
  created() {
	  if(loginText){
		  
    this.text = loginText;
	  }
  },
  methods: {
    dl() {
      this.$axios
        .post(this.$config.service.login, this.login)
        .then((res) => {
          console.log(res);
          if (res.data.result == "111111111111") {
            res.data.data.userinfo.logtime = Tools.presentTiem();
            let userInfo = JSON.stringify(res.data.data.userinfo);
            window.localStorage.setItem("userInfo", userInfo);
            window.localStorage.setItem("token", res.data.data.token);
            this.$message.success("登录成功");
            this.$router.push({ path: "/" });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error("服务器未响应!");
        });
    },
  },
};
</script>
<style type="text/css" lang="scss" scoped="scoped">
@media (max-width: 1400px) {
}
#loginbg {
  width: 100%;
  height: 100vh;
  min-width: 1400px;
  background: url(../assets/login/login_bg.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
  .login {
    height: 700px;
    background-color: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -350px;
    margin-left: -700px;
    display: flex;
    justify-content: space-between;
    .login_logo {
      width: 680px;
      padding: 27px 20px;
      .logo_logo {
        width: 178px;
        height: 52px;
        background: url(../assets/logo.png) no-repeat 100% 100%;
      }
      .logo_pic {
        width: 474px;
        height: 469px;
        background: url(../assets/login/pic.png) no-repeat 100% 100%;
        margin: 26px auto;
      }
    }
    .login_dlbg {
      width: 700px;
      text-align: center;
      .dlbg_title {
        font-size: 36px;
        color: #0080ff;
        margin-top: 164px;
      }
      .dlbg_username {
        width: 430px;
        height: 40px;
        margin-top: 68px;
      }
      .dlbg_password {
        width: 430px;
        height: 40px;
        margin-top: 40px;
      }
      .dlbg_dlbtn {
        width: 430px;
        height: 50px;
        margin-top: 60px;
      }
      .dlbg_company {
        font-size: 12px;
        letter-spacing: 0px;
        color: #333333;
        margin-top: 34px;
      }
    }
  }
}
</style>
